export default __webpack_public_path__ + "static/media/image-study-board-1-m.adb3df80.webp";